import {VIEW_ERROR} from "../../../reducers/editErrorReducer";
export const viewError = () =>{
    return {
        type: VIEW_ERROR,
        payload: {}
    }
}